import { Component, OnInit, EventEmitter, Output, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { mUser } from '../../../models/user.model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { AppService } from '../../../services/app.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-user-edit-form',
  templateUrl: './user-edit-form.component.html',
  styleUrls: ['./user-edit-form.component.scss']
})
export class UserEditFormComponent implements OnInit {
  @Output() closeDialogue = new EventEmitter();
  // genderList : any = [{"Id":1,"DisplayText":"Mannetje"},{"Id":2,"DisplayText":"Vrouw"},{"Id":3,"DisplayText":"anders"}];
  // roleList : any =  [{"Id":1,"DisplayText":"beheerder"},{"Id":2,"DisplayText":"Verkoopsmanager"},{"Id":3,"DisplayText":"Verkoper"}];
  //languageList : any =  [{"Id":1,"DisplayText":"English"}, {"Id":2,"DisplayText":"Dutch"}];

  genderList: any = [];
  roleList: any = [];
  languageList: any = [];

  fhMapping: any = [];
  userId: Number = 0;
  formGroup: FormGroup;
  formGroupErrors: any;
  user = new mUser();

  loadingIndicator = false;
  reorderable = true;
  nHide = false;
  translations: any;
  exPassword: String;
  clearInput: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA)
  public data: { Id: 0 },
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    public appService: AppService,
    private userService: UserService,
    public dialogRef: MatDialogRef<UserEditFormComponent>) {
      this.appService.showLoading();
    this.setPageTranslations();
    this.formGroupErrors = {
      Name: {},
      UserName: {},
      Email: {},
      Password: {},
      LanguageId: {},
      LastLoginDate: {},
      IsActive: {}
    };

      this.formGroup = this.formBuilder.group({
        Name: ['', Validators.required],
        UserName: ['', Validators.required],
        // Email: ['', [Validators.pattern(/^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/), Validators.required]],
        // Email: ["", Validators.pattern(/^([\w-\.]{1,64}((\[|\()?@(\]|\))?|(\[|\()?at(\]|\))?|(\[|\()?kukac(\]|\))?)[\w-]{1,64}((\[|\()?\.(\]|\))?|(\[|\()?dot(\]|\))?|(\[|\()?pont(\]|\))?)[a-zA-Z]{2,3})$/)],
        Email: ['', [Validators.pattern(/^([\w+-.%]+@[\w\-.]+\.[A-Za-z]{2,4};?)+$/)]],
        Password:  ['', Validators.required],
        LanguageId: ['', Validators.required],
        LastLoginDate: [{
          value: this.translations.lblLastLoginDate,
          disabled: true
        }],
        IsActive: ['', Validators.required]
      });
   
    this.userId = this.data.Id;
  }

  ngOnInit() {
    this.formGroup.valueChanges.subscribe(() => {
      this.formGroupErrors = this.appService.onFormValuesChanged(this.formGroup, this.formGroupErrors);

    });
    
    if (this.userId != 0)
      this.select();
    else
      this.selectLanguage();
  }

  setPageTranslations() {
    this.translations = JSON.parse(sessionStorage.getItem('pageData'));
  }

  select(): void {
    this.userService.select(this.userId).subscribe(
      res => this.selectBankSuccess(res),
      error => this.apiFaillure(error)
    );
  }
  selectBankSuccess(res): void {
    if (res.Status) {
      if (JSON.parse(res.Data).length > 0)
        this.user = JSON.parse(res.Data)[0];
      this.selectLanguage();
    } else {
      this.apiFaillure(this.translations[res.Message]);
    }
  }

  selectLanguage(): void {
    this.userService.selectLanguages(this.user.LanguageId).subscribe(
      res => this.selectLanguageSuccess(res),
      error => this.apiFaillure(error)
    );
  }
  selectLanguageSuccess(res) {
    this.appService.hideLoading();
    if (res.Status) {
      this.languageList = JSON.parse(res.Data);
    } else {
      this.apiFaillure(this.translations[res.Message]);
    }
  }

  apiFaillure(error): void {
    this.appService.hideLoading();
    this.appService.showDialogue("Error", error.Message);
  }
  close() {
    this.dialogRef.close();
  }

  save(): void {
    this.appService.showLoading();
    this.userService.save(JSON.stringify(this.user)).subscribe(
      res => this.saveUserSuccess(res),
      error => this.apiFaillure(error)
    );
  }
  saveUserSuccess(res): void {
    this.appService.hideLoading();
    if (res.Status) {
      this.appService.showDialogue("Success", this.translations[res.Message])
        .afterClosed().subscribe(result => {
          if (result) {
            this.close();
          }
        });
    } else {
      this.apiFaillure(this.translations[res.Message]);
    }
  }

  clearPassword(){
    this.exPassword = this.user.Password;
    this.user.Password = "";
    this.clearInput = true;
  }

  resetPassword(){
    this.user.Password = this.exPassword;
    this.clearInput = false;
  }
}





// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/user/user-edit-form/user-edit-form.component.ts